import { useQuery } from '@tanstack/react-query'

import { GetPopUpElementViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'

import { FetchPopupSearchParams, PopupReactQueryKey } from './constants'

interface Params {
    cat_id?: string
    tag_id?: string
    brand_id?: string
    isHomePage?: boolean
}

export function useGetPopup({ isHomePage, cat_id, tag_id, brand_id }: Params) {
    const requestParams = new URLSearchParams()

    if (cat_id) requestParams.append(FetchPopupSearchParams.CategoryId, cat_id.toString())
    if (tag_id) requestParams.append(FetchPopupSearchParams.TagId, tag_id.toString())
    if (brand_id) requestParams.append(FetchPopupSearchParams.BrandId, brand_id.toString())
    if (isHomePage) requestParams.append(FetchPopupSearchParams.IsHomePage, isHomePage.toString())

    const enabled = !!cat_id || !!tag_id || !!brand_id || isHomePage

    return useQuery<unknown, unknown, GetPopUpElementViewModel>({
        queryKey: [PopupReactQueryKey.Popup, cat_id, tag_id, brand_id, isHomePage],
        queryFn: () =>
            fetchRequest({
                endpoint: `/pop-up-elements?${requestParams.toString()}`,
                method: 'GET',
                serviceName: 'cml',
            }),
        enabled,
    })
}
